module.exports = __webpack_public_path__ + "img/logo.67e9faec.png";